// *************************** //
// COLORS
// *************************** //
export const colors = {
  // 'dark' :  'black',
  'dark' :  '#2A2D3D',
  'dark_1' :'#0B0C15',
  'dark_2' :'#2A2D3D',
  'dark_2_light' :'#2A2F50',
  'dark_3' :'#10111B',
  'light' :  'white',

  'turtledark':'#2CA066',
  'turtle': '#47BE08',
  'turtlelight':'#98DF90',
  'turtlevlight':'#C4EDC0',
  'turtlevvlight':'#E1F6DF',
  'turtlealphalight':'rgba(152,223,144,0.5)',
  'turtlealphalight2':'rgba(152,223,144,0.95)',
  
  // 'transp_card': 'rgba(128,128,128,.35)',
  'transp_card': 'rgba(223,161,128,.25)',
  'light_transp': 'rgba(255,255,255, 0.5)',
  'light_transp2': 'rgba(196,196,196, 0.3)', //#D9D9D9
  'light_transp3': 'rgba(255,255,255, 0.3)', 
  'lightgrey': '#DFE0E2', 
  'vlightgrey': '#EAECEC',
  'mediumgrey' :'#D4D6D8',
  'mediumgrey_transp': 'rgba(191,193,197, 0.2)',
  'darkgrey': 'rgba(0,0,0,0.6)',
  // '#81898E',
  'darkgrey_transp': 'rgba(136,136,136, 0.5)',
  'dark_transp': 'rgba(42, 45, 61, 0.7)', 
  'inactive':'#C8CFD8',
  'inactivelight':'#E7EAEE',
  'greyblue':'#3C3D4C',
  'greybluelight':'#5A5B72',

  
  'bright': '#82E4FD',
  'brightmed': '#AFEEFD',
  // 'brightdark': '#73C2FB',
  'brightdark': '#04C2F1',
  // 'brightlight': '#C3E9FE',
  'brightlight': '#C2F2FE',
  'brightvlight': '#EBF7FF',

  'pastel': '#FEAB80',
  'pasteldark': '#FD935D',
  'pastelvdark': '#DA5E1B',
  'pastelight' : '#F8DDC9',
  'ambervlight' : '#FCF4ED',

  'brightalpha' : 'rgba(130, 228, 253,0.5)',
  'brightalphalight' : 'rgba(130, 228, 253,0.4)',
  'pastelalpha' : 'rgba(241, 193, 159,0.5)',
  'pastelalphalight' : 'rgba(241, 193, 159,0.4)',
  'greyalpha' : 'rgba(196, 196, 196,0.5)',
  'greyalphalight' : 'rgba(196, 196, 196,0.2)',

  'error':'#FD8982',
  'errordark':'#E04B00',
  'errorlight':'#FED9D7',
  'errorvlight':'#FEECEB',
  'erroralpha':'rgba(253,137,130, 0.25)',

  'positive':'#8FE0B8',
  'positivedark': '#5FD399',
  'positivevdark': '#2CA066',
  'positivelight': '#9FE5C2',
  'positivevlight':'#DFF6EB',
  'positivealpha': 'rgba(143,224,184,0.5)',
  'positivealphalight': 'rgba(143,224,184,0.25)',
  'amber':'#FCBA5F',



 }

 export const androidcol =  '#FF5733'
 export const ioscol =  '#3498db'


export const  seacolors = {
  'level0':"#1D244B",
  'level1':'#252F5F',
  'level2': '#3a4487',
  'level3':'#5765C6',
  'sand':'#F0E2D1',
  'sand2':'#EAC9B7',

}